import React, { FC } from 'react';
import { ButtonIcon, Text } from '@cubeyou-team/hx-react-components';

import { TEST_IDS } from '../../constants/test';

interface StanleyQueryResultsSummaryProps {
  summary: string;
  onEditPrompt: () => void;
}

export const StanleyQueryResultsSummary: FC<
  StanleyQueryResultsSummaryProps
> = ({ summary, onEditPrompt }) => {
  return (
    <div className="flex items-start gap-3 rounded bg-white p-4">
      <div className="min-w-0 flex-1">
        <Text tag="span" size="x_body" weight="bold">
          Audience description:
        </Text>
        <Text
          tag="span"
          size="x_body"
          weight="regular"
          className="ml-1 whitespace-pre-wrap break-words"
        >
          {summary}
        </Text>
      </div>
      <ButtonIcon
        icon="edit"
        data-testid={TEST_IDS.STANLEY_QUERY_EDIT_PROMPT}
        onClick={onEditPrompt}
        size="small"
      />
    </div>
  );
};
